import axios from "axios";
import React, { useEffect, useState } from "react";

import config from '../../config';
import { headers } from "../../token";
import UpdateCompany from "./UpdateCompany";
import { Link } from "react-router-dom";
const server_backend = config.API_URL;

const Company = ({ username, userRole }) => {
    const [company, setCompany] = useState([]);
    const [IsUpdating, setIsUpdating] = useState(false);

    useEffect(() => {
        const getCompany = async () => {
            try {
                const response = await axios.get(`${server_backend}/company/select?id=${1}`, headers);
                console.log("Unexpected error, please check")
                setCompany(response.data.RES_RESULT[0]);
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        };
        getCompany();
    }, []);

    const getCompany = async () => {
        try {
            const response = await axios.get(`${server_backend}/company/select?id=${1}`, headers);
            setCompany(response.data.RES_RESULT[0]);
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    };

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    };

    const CloseModal = () => {
        setIsUpdating(false);
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                {!IsUpdating ? (
                    <div>
                        <div className="profile-foreground position-relative mx-n4 mt-n4">
                            <div className="fade-down" style={{
                                position: "absolute",
                                left: 0,
                                right: 0,
                                top: 0,
                                height: "420px"
                            }}>
                                <img src="/assets/images/dbc-entrance-2.jpg" alt="none" style={{
                                    position: "absolute",
                                    left: 0,
                                    right: 0,
                                    top: 0,
                                    bottom: 0,
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    backgroundColor: "rgba(0, 0, 0, 0.8)"
                                }} />
                            </div>
                        </div>
                        <div className="pt-4 mb-4 mb-lg-3 pb-lg-4">
                            <div className="row g-4">
                                <div className="col-auto">
                                    <div className="avatar-lg">
                                        <img src="/assets/images/dbclondon-sm.jpg" alt="user-img" className="img-thumbnail rounded-circle" />
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="p-2">
                                        <h3 className="text-white mb-1">{company.name || ''}</h3>
                                        <p className="text-white-75">{company.city || ''}</p>
                                        <div className="hstack text-white-50 gap-1">
                                            <div className="me-2">
                                                <i className="ri-map-pin-user-line me-1 text-white-75 fs-16 align-middle"></i>
                                                {company.city || ''}
                                            </div>
                                            <div>
                                                <i className="ri-building-line me-1 text-white-75 fs-16 align-middle"></i>
                                                {company.country || ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12 card">
                                <div>
                                    <div className="d-flex justify-content-end" style={{ marginBlock: "10px" }}>
                                        <div className="ms-auto">
                                            <Link onClick={ShowModalUpdate} className="btn btn-success">
                                                <i className="ri-edit-box-line align-bottom"></i> Edit Company
                                            </Link>
                                        </div>
                                    </div>


                                    <div className="tab-content pt-4 text-muted">
                                        <div className="tab-pane active" id="overview-tab" role="tabpanel">
                                            <div className="row">
                                                <div className="col-5">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <h5 className="card-title mb-3">General Info</h5>
                                                            <div className="table-responsive">
                                                                <table className="table table-borderless mb-0">
                                                                    <tbody>
                                                                        <tr>
                                                                            <th className="ps-0" scope="row">Company Name:</th>
                                                                            <td className="text-muted">{company.name || ''}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th className="ps-0" scope="row">Mobile:</th>
                                                                            <td className="text-muted">{company.phone || ''}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th className="ps-0" scope="row">E-mail:</th>
                                                                            <td className="text-muted">{company.email || ''}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th className="ps-0" scope="row">Location:</th>
                                                                            <td className="text-muted">{`${company.city || ''} ${company.country || ''}`}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th className="ps-0" scope="row">Country:</th>
                                                                            <td className="text-muted">{company.country || ''}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th className="ps-0" scope="row">Phone:</th>
                                                                            <td className="text-muted">{company.phone || ''}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th className="ps-0" scope="row">Phone 2:</th>
                                                                            <td className="text-muted">{company.phone2 || ''}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-7">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <h5 className="card-title mb-3">Additional Info</h5>
                                                            <table className="table table-borderless mb-0">
                                                                <tbody>
                                                                    <tr>
                                                                        <th className="ps-0" scope="row">Website:</th>
                                                                        <td className="text-muted">{company.website || ''}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="ps-0" scope="row">Post Code:</th>
                                                                        <td className="text-muted">{company.zipcode || ''}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="ps-0" scope="row">Status Name:</th>
                                                                        <td className="text-muted">{company.status_name || ''}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                            <br /><br />
                                                            <h5 className="card-title mb-3">About</h5>
                                                            <p>{company.comment || ''}</p>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                ) : (
                    <div>
                        <UpdateCompany username={username} onCompanyID={company.cmp_ID} getCompany={getCompany} onClose={CloseModal} />
                    </div>
                )}
            </div>
        </div>
    )
}

export default Company;
